import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../css/style.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import IndustriesSection from '../components/IndustriesSection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBullseye,
  faEye,
  faScaleBalanced,
  faChartLine,
  faClockRotateLeft,
  faCrosshairs,
  faBolt,
  faRobot
} from '@fortawesome/free-solid-svg-icons';

class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeService: null,
      selectedCategory: 'all'
    };
  }

  handleServiceHover = (serviceId) => {
    this.setState({ activeService: serviceId });
  }

  handleServiceLeave = () => {
    this.setState({ activeService: null });
  }

  handleCategoryFilter = (category) => {
    this.setState({ selectedCategory: category });
  }

  render() {
    const { activeService, selectedCategory } = this.state;

    const services = [
      {
        id: 1,
        category: 'surveillance',
        title: 'AI-Powered Video Surveillance',
        description: 'Advanced camera systems with intelligent analytics for comprehensive monitoring and threat detection.',
        features: ['4K Ultra HD Recording', 'Facial Recognition', 'Motion Analytics', 'Cloud Storage', 'Mobile Access'],
        icon: '',
        price: ''
      },
      {
        id: 2,
        category: 'access',
        title: 'Smart Access Control',
        description: 'Biometric and card-based systems with AI-enhanced security protocols for complete access management.',
        features: ['Biometric Authentication', 'Multi-Factor Access', 'Real-time Monitoring', 'Visitor Management', 'Integration Ready'],
        icon: '',
        price: ''
      },
      {
        id: 3,
        category: 'monitoring',
        title: '24/7 Security Monitoring',
        description: 'Round-the-clock professional monitoring with AI-assisted threat analysis and rapid response protocols.',
        features: ['24/7 Live Monitoring', 'AI Threat Analysis', 'Emergency Response', 'Detailed Reporting', 'Mobile Alerts'],
        icon: '',
        price: ''
      },
      {
        id: 4,
        category: 'intrusion',
        title: 'Intrusion Detection Systems',
        description: 'Intelligent sensors and alarms that distinguish between genuine threats and false alarms using AI.',
        features: ['Smart Sensors', 'False Alarm Reduction', 'Perimeter Protection', 'Wireless Options', 'Instant Notifications'],
        icon: '',
        price: ''
      },
      {
        id: 5,
        category: 'fire',
        title: 'Fire Safety & Detection',
        description: 'Comprehensive fire detection and suppression systems with intelligent smoke and heat analysis.',
        features: ['Smart Smoke Detection', 'Heat Sensors', 'Suppression Systems', 'Emergency Protocols', 'Code Compliance'],
        icon: '',
        price: ''
      },
      {
        id: 6,
        category: 'analytics',
        title: 'Security Analytics Platform',
        description: 'AI-driven analytics dashboard providing insights, patterns, and predictive security intelligence.',
        features: ['Predictive Analytics', 'Custom Reports', 'Pattern Recognition', 'Risk Assessment', 'Data Visualization'],
        icon: '',
        price: ''
      }
    ];

    const filteredServices = selectedCategory === 'all' 
      ? services 
      : services.filter(service => service.category === selectedCategory);

    return (
      <div>
        {/* Hero Banner */}
        {/* <Navbar/> */}
        <section className="general-banner">
          <div className="container">
            <div className="general-content">
              <h1 className="hero-title orbitron">Our Services</h1>
              <p className="hero-subtitle">Comprehensive AI-powered security solutions tailored to your needs</p>
            </div>
          </div>
        </section>

        {/* Services Overview */}
        <section className="py-5" style={{ backgroundColor: 'var(--primary-dark)', color: 'var(--text-primary)' }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto text-center mb-5">
                <h2 className="display-5 fw-bold mb-4 orbitron">Complete Security Solutions</h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  From AI-powered surveillance to intelligent access control, we provide cutting-edge security 
                  technologies that adapt to your unique requirements. Our integrated approach ensures 
                  comprehensive protection for businesses of all sizes.
                </p>
              </div>
            </div>

            {/* Service Categories Filter */}
            <div className="row mb-5">
              <div className="col-12">
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  <button 
                    className={`btn ${selectedCategory === 'all' ? 'btn-primary' : 'btn-outline-light'} px-3 py-2`}
                    onClick={() => this.handleCategoryFilter('all')}
                  >
                    All Services
                  </button>
                  <button 
                    className={`btn ${selectedCategory === 'surveillance' ? 'btn-primary' : 'btn-outline-light'} px-3 py-2`}
                    onClick={() => this.handleCategoryFilter('surveillance')}
                  >
                    Surveillance
                  </button>
                  <button 
                    className={`btn ${selectedCategory === 'access' ? 'btn-primary' : 'btn-outline-light'} px-3 py-2`}
                    onClick={() => this.handleCategoryFilter('access')}
                  >
                    Access Control
                  </button>
                  <button 
                    className={`btn ${selectedCategory === 'monitoring' ? 'btn-primary' : 'btn-outline-light'} px-3 py-2`}
                    onClick={() => this.handleCategoryFilter('monitoring')}
                  >
                    Monitoring
                  </button>
                  <button 
                    className={`btn ${selectedCategory === 'analytics' ? 'btn-primary' : 'btn-outline-light'} px-3 py-2`}
                    onClick={() => this.handleCategoryFilter('analytics')}
                  >
                    Analytics
                  </button>
                </div>
              </div>
            </div>

            {/* Services Grid */}
            <div className="row">
              {filteredServices.map(service => (
                <div key={service.id} className="col-lg-4 col-md-6 mb-4">
                  <div 
                    className={`h-100 p-4 rounded-3 position-relative transition-all ${
                      activeService === service.id ? 'shadow-lg' : ''
                    }`}
                    style={{ 
                      backgroundColor: 'var(--box-dark-bg)',
                      border: activeService === service.id 
                        ? '2px solid var(--icons-color)' 
                        : '1px solid var(--secondary-dark)',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={() => this.handleServiceHover(service.id)}
                    onMouseLeave={this.handleServiceLeave}
                  >
                    <div className="text-center mb-3">
                      {/* <div 
                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{ 
                          width: '70px', 
                          height: '70px', 
                          backgroundColor: activeService === service.id ? 'var(--icons-color)' : 'var(--secondary-dark)',
                          fontSize: '1.8rem',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        {service.icon}
                      </div> */}
                      <h4 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>
                        {service.title}
                      </h4>
                      <p className="mb-3" style={{ color: 'var(--text-secondary)' }}>
                        {service.description}
                      </p>
                    </div>

                    <div className="mb-4">
                      <h6 className="orbitron mb-2" style={{ color: 'var(--text-primary)' }}>Key Features:</h6>
                      <ul className="list-unstyled">
                        {service.features.map((feature, index) => (
                          <li key={index} className="mb-1 d-flex align-items-center">
                            <span 
                              className="me-2"
                              style={{ color: 'var(--accent-cyan)', fontSize: '0.8rem' }}
                            >
                              ✓
                            </span>
                            <small style={{ color: 'var(--text-secondary)' }}>{feature}</small>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="mt-auto">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="fw-bold" style={{ color: 'var(--accent-cyan)' }}>
                          {service.price}
                        </span>
                      </div>
                      {/* <div className="d-flex gap-2">
                        <button className="btn btn-primary btn-sm flex-fill">Learn More</button>
                        <button className="btn btn-outline-light btn-sm flex-fill">Get Quote</button>
                      </div> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* AI Technology Integration */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--secondary-dark)' }}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <h2 className="display-5 fw-bold mb-4 orbitron" style={{ color: 'var(--text-primary)' }}>
                  AI-Enhanced Security
                </h2>
                <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
                  Every service is powered by our proprietary artificial intelligence platform that learns, 
                  adapts, and evolves to provide superior protection. Our AI doesn't just detect threats—it 
                  predicts them, reducing false alarms and improving response times.
                </p>
                
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div 
                        className="me-3 rounded-circle d-flex align-items-center justify-content-center"
                        style={{ 
                          width: '40px', 
                          height: '40px', 
                          backgroundColor: 'var(--accent-cyan)',
                          fontSize: '1.2rem'
                        }}
                      >
                        🧠
                      </div>
                      <div>
                        <h6 className="orbitron mb-1" style={{ color: 'var(--text-primary)' }}>
                          Machine Learning
                        </h6>
                        <small style={{ color: 'var(--text-secondary)' }}>
                          Continuously improving threat detection accuracy
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div 
                        className="me-3 rounded-circle d-flex align-items-center justify-content-center"
                        style={{ 
                          width: '40px', 
                          height: '40px', 
                          backgroundColor: 'var(--accent-blue)',
                          fontSize: '1.2rem'
                        }}
                      >
                        ⚡
                      </div>
                      <div>
                        <h6 className="orbitron mb-1" style={{ color: 'var(--text-primary)' }}>
                          Real-time Analysis
                        </h6>
                        <small style={{ color: 'var(--text-secondary)' }}>
                          Instant threat assessment and response
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div 
                        className="me-3 rounded-circle d-flex align-items-center justify-content-center"
                        style={{ 
                          width: '40px', 
                          height: '40px', 
                          backgroundColor: 'var(--icons-color)',
                          fontSize: '1.2rem'
                        }}
                      >
                        🎯
                      </div>
                      <div>
                        <h6 className="orbitron mb-1" style={{ color: 'var(--text-primary)' }}>
                          Predictive Security
                        </h6>
                        <small style={{ color: 'var(--text-secondary)' }}>
                          Anticipating threats before they occur
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div 
                        className="me-3 rounded-circle d-flex align-items-center justify-content-center"
                        style={{ 
                          width: '40px', 
                          height: '40px', 
                          backgroundColor: 'var(--accent-cyan)',
                          fontSize: '1.2rem'
                        }}
                      >
                        📈
                      </div>
                      <div>
                        <h6 className="orbitron mb-1" style={{ color: 'var(--text-primary)' }}>
                          Smart Analytics
                        </h6>
                        <small style={{ color: 'var(--text-secondary)' }}>
                          Actionable insights from security data
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div 
                  className="p-4 rounded-3"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div className="text-center mb-4">
                    <div 
                      className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                      style={{ 
                        width: '80px', 
                        height: '80px', 
                        backgroundColor: 'var(--icons-color)',
                        fontSize: '2rem'
                      }}
                    >
                      🤖
                    </div>
                    <h4 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>
                      AI Integration Benefits
                    </h4>
                  </div>
                  
                  <div className="row text-center">
                    <div className="col-4">
                      <div className="mb-2">
                        <div className="display-6 fw-bold orbitron" style={{ color: 'var(--accent-cyan)' }}>
                          95%
                        </div>
                        <small style={{ color: 'var(--text-secondary)' }}>Accuracy Rate</small>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="mb-2">
                        <div className="display-6 fw-bold orbitron" style={{ color: 'var(--accent-blue)' }}>
                          80%
                        </div>
                        <small style={{ color: 'var(--text-secondary)' }}>Faster Response</small>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="mb-2">
                        <div className="display-6 fw-bold orbitron" style={{ color: 'var(--icons-color)' }}>
                          70%
                        </div>
                        <small style={{ color: 'var(--text-secondary)' }}>Less False Alarms</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section className="py-5" style={{ backgroundColor: 'var(--secondary-dark)' }}>
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-lg-6 mb-4 mb-lg-0">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <div 
                              className="p-3 rounded-3 text-center h-100"
                              style={{ backgroundColor: 'var(--box-dark-bg)' }}
                            >
                              <div className="mb-2" style={{ fontSize: '2rem' }}><FontAwesomeIcon icon={faChartLine} /></div>
                              <h6 className="orbitron" style={{ color: 'var(--text-primary)' }}>Smart Analytics</h6>
                              <small style={{ color: 'var(--text-secondary)' }}>
                                AI-powered behavioral analysis and threat detection
                              </small>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <div 
                              className="p-3 rounded-3 text-center h-100"
                              style={{ backgroundColor: 'var(--box-dark-bg)' }}
                            >
                              <div className="mb-2" style={{ fontSize: '2rem' }}><FontAwesomeIcon icon={faClockRotateLeft} /></div>
                              <h6 className="orbitron" style={{ color: 'var(--text-primary)' }}>Real-time Monitoring</h6>
                              <small style={{ color: 'var(--text-secondary)' }}>
                                Continuous surveillance with instant alerts
                              </small>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <div 
                              className="p-3 rounded-3 text-center h-100"
                              style={{ backgroundColor: 'var(--box-dark-bg)' }}
                            >
                              <div className="mb-2" style={{ fontSize: '2rem' }}><FontAwesomeIcon icon={faCrosshairs} /></div>
                              <h6 className="orbitron" style={{ color: 'var(--text-primary)' }}>Precision Detection</h6>
                              <small style={{ color: 'var(--text-secondary)' }}>
                                Advanced algorithms for accurate threat identification
                              </small>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <div 
                              className="p-3 rounded-3 text-center h-100"
                              style={{ backgroundColor: 'var(--box-dark-bg)' }}
                            >
                              <div className="mb-2" style={{ fontSize: '2rem' }}><FontAwesomeIcon icon={faBolt} /></div>
                              <h6 className="orbitron" style={{ color: 'var(--text-primary)' }}>Rapid Response</h6>
                              <small style={{ color: 'var(--text-secondary)' }}>
                                Automated emergency protocols and notifications
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <h2 className="display-5 fw-bold mb-4 orbitron" style={{ color: 'var(--text-primary)' }}>
                          AI-Powered Security Innovation
                        </h2>
                        <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
                          Our proprietary artificial intelligence technology revolutionizes traditional security monitoring. 
                          By leveraging machine learning algorithms and advanced pattern recognition, we deliver security 
                          solutions that are not just reactive, but predictive.
                        </p>
                        <div className="mb-4">
                          <h5 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>Key AI Features:</h5>
                          <ul style={{ color: 'var(--text-secondary)' }}>
                            <li className="mb-2">Facial recognition and access control</li>
                            <li className="mb-2">Anomaly detection and behavioral analysis</li>
                            <li className="mb-2">Predictive threat assessment</li>
                            <li className="mb-2">Automated incident response</li>
                            <li className="mb-2">Integration with existing security infrastructure</li>
                          </ul>
                        </div>
                        {/* <button className="btn btn-primary btn-lg">
                          Learn More About Our AI Technology
                        </button> */}
                      </div>
                    </div>
                  </div>
                </section>

        {/* Service Process */}
        <section className="py-5" style={{ backgroundColor: 'var(--primary-dark)', color: 'var(--text-primary)' }}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <h2 className="display-5 fw-bold orbitron">Our Process</h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  From consultation to implementation, we ensure seamless security integration
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-6 mb-4">
                <div className="text-center">
                  {/* <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 position-relative"
                    style={{ 
                      width: '80px', 
                      height: '80px', 
                      backgroundColor: 'var(--icons-color)',
                      fontSize: '1.5rem'
                    }}
                  >
                    <span 
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                      style={{ backgroundColor: 'var(--accent-cyan)' }}
                    >
                      1
                    </span>
                    📋
                  </div> */}
                  <h5 className="orbitron mb-3">Assessment</h5>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    Comprehensive security audit and risk analysis of your premises and current systems.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-4">
                <div className="text-center">
                  {/* <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 position-relative"
                    style={{ 
                      width: '80px', 
                      height: '80px', 
                      backgroundColor: 'var(--accent-cyan)',
                      fontSize: '1.5rem'
                    }}
                  >
                    <span 
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                      style={{ backgroundColor: 'var(--icons-color)' }}
                    >
                      2
                    </span>
                    🎯
                  </div> */}
                  <h5 className="orbitron mb-3">Custom Design</h5>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    Tailored security solution design based on your specific needs and budget requirements.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-4">
                <div className="text-center">
                  {/* <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 position-relative"
                    style={{ 
                      width: '80px', 
                      height: '80px', 
                      backgroundColor: 'var(--accent-blue)',
                      fontSize: '1.5rem'
                    }}
                  >
                    <span 
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                      style={{ backgroundColor: 'var(--accent-cyan)' }}
                    >
                      3
                    </span>
                    🔧
                  </div> */}
                  <h5 className="orbitron mb-3">Installation</h5>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    Professional installation by certified technicians with minimal disruption to operations.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-4">
                <div className="text-center">
                  {/* <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 position-relative"
                    style={{ 
                      width: '80px', 
                      height: '80px', 
                      backgroundColor: 'var(--secondary-dark)',
                      fontSize: '1.5rem'
                    }}
                  >
                    <span 
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                      style={{ backgroundColor: 'var(--icons-color)' }}
                    >
                      4
                    </span>
                    🛡️
                  </div> */}
                  <h5 className="orbitron mb-3">Ongoing Support</h5>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    24/7 monitoring, maintenance, and continuous system optimization for peak performance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Industries We Serve */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--secondary-dark)' }}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <h2 className="display-5 fw-bold orbitron" style={{ color: 'var(--text-primary)' }}>
                  Industries We Serve
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Specialized security solutions for diverse business sectors
                </p>
              </div>
            </div>
            <div className="row">
              {[
                { icon: '🏢', title: 'Corporate Offices', desc: 'Executive protection and facility security' },
                { icon: '🏪', title: 'Retail Stores', desc: 'Loss prevention and customer safety' },
                { icon: '🏭', title: 'Manufacturing', desc: 'Industrial security and asset protection' },
                { icon: '🏥', title: 'Healthcare', desc: 'Patient safety and HIPAA compliance' },
                { icon: '🏫', title: 'Education', desc: 'Campus security and student protection' },
                { icon: '🏛️', title: 'Government', desc: 'High-security clearance facilities' }
              ].map((industry, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div 
                    className="p-4 rounded-3 text-center h-100"
                    style={{ backgroundColor: 'var(--box-dark-bg)' }}
                  >
                    <div className="mb-3" style={{ fontSize: '2.5rem' }}>{industry.icon}</div>
                    <h5 className="orbitron mb-2" style={{ color: 'var(--text-primary)' }}>
                      {industry.title}
                    </h5>
                    <p style={{ color: 'var(--text-secondary)' }}>{industry.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}
        {/* <IndustriesSection/> */}

        {/* Call to Action */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--primary-dark)' }}>
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                <h2 className="display-5 fw-bold mb-4 orbitron" style={{ color: 'var(--text-primary)' }}>
                  Ready to Upgrade Your Security?
                </h2>
                <p className="lead mb-4" style={{ color: 'var(--text-secondary)' }}>
                  Get a free security assessment and discover how our AI-powered solutions can protect your business. 
                  Our experts are ready to design a custom security package that fits your needs and budget.
                </p>
                <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                  <button className="btn btn-primary btn-lg px-4">
                    📞 Get Free Assessment
                  </button>
                  <button className="btn btn-outline-light btn-lg px-4">
                    💬 Chat with Expert
                  </button>
                </div>
                <div className="mt-4">
                  <small style={{ color: 'var(--text-secondary)' }}>
                    ✓ No obligation consultation &nbsp;&nbsp; 
                    ✓ 24/7 emergency support &nbsp;&nbsp; 
                    ✓ Licensed & insured
                  </small>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        
      </div>
    );
  }
}

export default Services;